import React, { useState } from 'react';
import { 
  Box, 
  Paper,
  Tabs,
  Tab,
} from '@mui/material';
import WarehouseList from './WarehouseList';
import ZipcodeList from './ZipcodeList';
import UploadHistory from './UploadHistory';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`zipcode-tabpanel-${index}`}
      aria-labelledby={`zipcode-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

const ZipcodePage = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={currentTab} 
            onChange={handleTabChange}
            aria-label="zipcode management tabs"
          >
            <Tab label="Warehouses" id="zipcode-tab-0" />
            <Tab label="Zipcodes" id="zipcode-tab-1" />
            <Tab label="Upload History" id="zipcode-tab-2" />
          </Tabs>
        </Box>

        <TabPanel value={currentTab} index={0}>
          <WarehouseList />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <ZipcodeList />
        </TabPanel>

        <TabPanel value={currentTab} index={2}>
          <UploadHistory />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default ZipcodePage;
